import {
    ScheduleTypes,
} from '../ActionTypes/ScheduleTypes';

class ScheduleActions {

    static getActiveSchedule = payload => {
        return {
            type: ScheduleTypes.GET_ACTIVE_SCHEDULE,
            payload: payload,
        };
    };

    static clearActiveSchedule = () => {
        return {
            type: ScheduleTypes.CLEAR_ACTIVE_SCHEDULE,
        };
    };

    static getPastSchedule = payload => {
        return {
            type: ScheduleTypes.GET_PAST_SCHEDULE,
            payload: payload,
        };
    };

    static clearPastSchedule = () => {
        return {
            type: ScheduleTypes.CLEAR_PAST_SCHEDULE,
        };
    };
    static getAllSchedule = payload => {
        return {
            type: ScheduleTypes.GET_ALL_SCHEDULE,
            payload: payload,
        };
    };

    static clearAllSchedule = () => {
        return {
            type: ScheduleTypes.CLEAR_ALL_SCHEDULE,
        };
    };
}

export default ScheduleActions;
